module.exports = __webpack_public_path__ + "static/media/6.f852d514.jpg";